/**
 * Fired when the reader finalises (signs) a report. Any plugin subscribed
 * to on_report_signed via its manifest.capabilities.triage.triggerMoments
 * gets a POST /triage/study/{id}/report_signed with the report text.
 *
 * Vendor-specific semantics: LIRA uploads the text + flips its own status
 * to SIGN_OFF. A future HL7 forwarder plugin could translate+relay.
 */

import { pluginsForTrigger } from '../registry';
import { writeAudit } from '../audit';

export async function notifyReportSigned(
  studyId: string,
  reportText: string,
): Promise<void> {
  const plugins = pluginsForTrigger('on_report_signed');
  await Promise.all(
    plugins.map(async (p) => {
      try {
        const resp = await fetch(
          `${p.baseUrl}/triage/study/${encodeURIComponent(studyId)}/report_signed`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ report_text: reportText }),
          },
        );
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        await writeAudit(p, {
          plugin_id: p.manifest.id,
          study_id: studyId,
          moment: 'on_report_signed',
          action: 'send',
        });
      } catch (err) {
        await writeAudit(p, {
          plugin_id: p.manifest.id,
          study_id: studyId,
          moment: 'on_report_signed',
          action: 'error',
          error: err instanceof Error ? err.message : String(err),
        });
      }
    }),
  );
}
